import {
    getDeliveryPointRouteLoading,
    getDeliveryPointRouteReject,
    getDeliveryPointRouteRequest,
    getDeliveryPointRouteSuccess
} from "../../actions/deliveryPointRoute/getAll";

export const getDeliveryPointRoute = (formData) => async (dispatch, getState) => {
    dispatch(getDeliveryPointRouteLoading());
    try {
        const { data } = await getDeliveryPointRouteRequest(formData, getState);
        dispatch(getDeliveryPointRouteSuccess(data))
    } catch (error) {
        dispatch(getDeliveryPointRouteReject(error))
    }
    return Promise.resolve();
};